import { useAuthContext } from 'contexts';
import { fhirGet } from 'services';
import useSWR from 'swr';
import type { PatientData } from 'types';
import { defaultSWROptions } from 'utils';

export const useGetPatient = (orgId: string, searchString: string, inactive?: boolean) => {
  const { token } = useAuthContext();
  let key: string;

  // if phone number, search all formats
  if (searchString && /^\d{10}$/.test(searchString)) {
    const normalized = searchString;
    const dashed = `${normalized.slice(0, 3)}-${normalized.slice(3, 6)}-${normalized.slice(6)}`;
    const parenthesized = `(${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6)}`;

    key = `/Patient/?_content:contains=${normalized},${dashed},${parenthesized}${orgId !== 'ALL' ? `&organization=${orgId}` : ''}${inactive ? '' : '&identifier:not=INACTIVE'}`;
  }

  if (orgId === 'ALL') {
    //do not fetch patient if searchString is empty under all organization
    key = `/Patient/?${searchString ? '_content:contains=' + searchString : '_content:contains=patient'}${inactive ? '' : '&identifier:not=INACTIVE'}`;
  } else {
    key = `/Patient/?${searchString ? '_content:contains=' + searchString : '_count=100'}&organization=${orgId}${inactive ? '' : '&identifier:not=INACTIVE'}`;
  }
  const url = key;

  const { data: patientData, isValidating } = useSWR<PatientData | undefined, string>(
    [url, token],
    fhirGet,
    defaultSWROptions
  );

  return { isValidating, patientData };
};
